import { useContext, useEffect, useState } from "react";
import { LoginContext } from "../../contexts/LoginContext";
import { AppContext } from "../../contexts/AppContext";
import MaterialsRequiresAPI from "../../services/MaterialsRequiresAPI";

const useMaterialsRequiresPresenter = (tableRef) => {
  const { showError, showWarning, showSuccess } = useContext(AppContext);
  const [firstLoad, setFirstLoad] = useState(true);
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [loadingChangeRequires, setLoadingChangeRequires] = useState(false);
  const [open, setOpen] = useState(false);
  const [code, setCode] = useState("");
  const [name, setName] = useState("");
  const [openExclusion, setOpenExclusion] = useState(false);
  const [openExclusionOrder, setOpenExclusionOrder] = useState(false);

  const [openAdd, setOpenAdd] = useState(false);

  const [openActivity, setOpenActivity] = useState(false);

  useEffect(() => {
    search();
    
  }, []);


  const cleanFilters = () => {
    setCode("");
    setName("");

  };

  const search = () => {
    const request = {
      code: !code.isBlank() ? code : "",
      name: !name.isBlank() ? name : "",
    };

    firstLoad && setFirstLoad(false);
    setLoading(true);
    setSelectedRows([]);

    MaterialsRequiresAPI.getMaterialsRequires(request)
      .then((res) => setRows(res.data))
      .catch((error) => showError("Error al obtener los registros"))
      .finally(() => setLoading(false));
  };

  const reloadGrid = () => {
      search();
  };

  const validateFilters = () => {

    let errors = [];
    const errorMessages = [];
    let i = 0;

    if ((errors[i++] = !code && !name)) {
      errorMessages.push(
        "Debe ingresar un valor en los filtros para iniciar la búsqueda"
      );
    }

    const hasErrors = errors.some((e) => e);
    hasErrors && showWarning(errorMessages);
    return !hasErrors;
  };

  const validateAndSearch = () => validateFilters() && search();

  return {
    code,
    setCode,
    name,
    setName,
    validateAndSearch,
    cleanFilters,

    search,

    rows,
    firstLoad,
    loading,

    gridFunctions: {
      reloadGrid,
      selectedRows,
      setSelectedRows,
      open,
      setOpen,
      openExclusion,
      setOpenExclusion,
      openExclusionOrder,
      setOpenExclusionOrder,

      openAdd,
      setOpenAdd,

      openActivity,
      setOpenActivity,

      gridActions: {
        loadingChangeRequires,
      },
    },

  };
};

export default useMaterialsRequiresPresenter;
